import {
  featureFilter,
  featureFilterUnselectedTourLine,
  filterHitArea,
  filterOriginalLocation,
  isPedestrianRoute,
  isUndesiredLine,
  isUndesiredPoint,
} from 'utils/map/MapFeatureFilters';
import {
  createTourPolyline,
  getHitAreaPolylineStyle,
  getOriginalLocationPolylineStyle,
  getPolylineStyle,
  getUnselectedPolylineStyle,
} from './tourLineFactory';
import { attachPolylineContextMenuEvent, attachPolylineTapEvent } from './tourLineEvents';

const toPolyline = (feature, styleConfig) =>
  createTourPolyline(
    feature,
    getPolylineStyle(feature, styleConfig.gradientRoutes, styleConfig.fleetType, styleConfig.showOverlaps),
  );

const buildLinePolylines = (features, display, routingData, styleConfig, showStraightRouteLines) => {
  const { regular, pedestrian } = features.reduce(
    (acc, f) => {
      if (featureFilter(f, display, routingData, showStraightRouteLines) && !isUndesiredPoint(f)) {
        (isPedestrianRoute(f) ? acc.pedestrian : acc.regular).push(f);
      }
      return acc;
    },
    { regular: [], pedestrian: [] },
  );
  return [...regular, ...pedestrian].map((f) => toPolyline(f, styleConfig));
};

export const buildStraightRoutePolylines = (mapData, display, routingData, styleConfig) => {
  const lineFeatures = mapData?.geo?.features?.filter((f) => f.geometry.type === 'LineString');
  if (!lineFeatures?.length) return [];
  return buildLinePolylines(lineFeatures, display, routingData, styleConfig, true);
};

export const buildRoutingPolylines = (routingRoutes, display, routingData, styleConfig) => {
  const { regular, pedestrian, undesired } = routingRoutes.features.reduce(
    (acc, f) => {
      if (isUndesiredLine(f)) {
        acc.undesired.push(f);
      } else if (featureFilter(f, display, routingData) && !isUndesiredPoint(f)) {
        (isPedestrianRoute(f) ? acc.pedestrian : acc.regular).push(f);
      }
      return acc;
    },
    { regular: [], pedestrian: [], undesired: [] },
  );
  const result = [...regular, ...pedestrian];
  if (styleConfig.showOverlaps) result.push(...undesired);
  return result.map((f) => toPolyline(f, styleConfig));
};

export const buildUnselectedPolylines = (routingRoutes, display) =>
  routingRoutes.features
    .filter((f) => featureFilterUnselectedTourLine(f, display) && !isUndesiredPoint(f))
    .map((feature) => createTourPolyline(feature, getUnselectedPolylineStyle()));

export const buildOriginalLocationPolylines = (originalLocation, display) => {
  if (!originalLocation?.features) return [];
  return originalLocation.features
    .filter((f) => filterOriginalLocation(f, display) && !isUndesiredPoint(f))
    .map((feature) => createTourPolyline(feature, getOriginalLocationPolylineStyle()));
};

export const buildHitAreaPolylines = (
  routingRoutes,
  display,
  routingData,
  onTourLineClick,
  onToggleHiddenSegment,
) => {
  const features = routingRoutes.features.filter((f) => filterHitArea(f, display, routingData));
  return features.map((feature) => {
    const polyline = createTourPolyline(feature, getHitAreaPolylineStyle());
    attachPolylineTapEvent(polyline, feature, onTourLineClick);
    attachPolylineContextMenuEvent(polyline, feature, onToggleHiddenSegment);
    return polyline;
  });
};
